<script lang="ts">
	import type { ComponentType } from 'svelte';

	import SettingsItemBoundary from './SettingsItemBoundary.svelte';

	export let component: ComponentType;
	export let componentProps: Record<string, unknown> = {};
	export let idPrefix = 'settings-item';
	export let passIsMobile = false;
	export let isMobile = false;
</script>

<SettingsItemBoundary {idPrefix}>
	{#if passIsMobile}
		<svelte:component this={component} {isMobile} {...componentProps} />
	{:else}
		<svelte:component this={component} {...componentProps} />
	{/if}
</SettingsItemBoundary>
